module.exports = __webpack_public_path__ + "static/img/18.cd6c0e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/18.png
// module id = 75YI
// module chunks = 0